import styled from "styled-components";

export const ListWrapper = styled.ul`
  list-style-type: none;
  padding-inline-start: 8px;
  margin-block: 4px;
`;
